import React from 'react';

import PendencyModal from 'design-system/PendencyModal';

import { PENDENCIAS_TEXTS } from '../constants';
import CallCenterContent from './CallCenterContent';

type CallCenterModalProps = {
  open: boolean;
  onClose: () => void;
};

const CallCenterModal = ({
  open,
  onClose,
}: CallCenterModalProps): JSX.Element => (
  <PendencyModal
    open={open}
    title={PENDENCIAS_TEXTS.MODAL_CALL_CENTER_TITLE}
    onClose={onClose}
    width={520}
  >
    <CallCenterContent />
  </PendencyModal>
);

export default CallCenterModal;
